import apiUrl from '../../../../../utils/settings';

export const GetAnnouncedGiftsProductsListUrl = () => {
  return apiUrl + '/users-gifts/announced-gift-products-list';
};
export const GetMyRetailersGiftTransactionsUrl = () => {
  return apiUrl + '/users-gifts/dealer-gifts-to-mason-through-retailer/';
};
export const getAllRewardsURL = () => {
  return apiUrl + '/user-gifts-v2/all-gifts';
};
export const getgiftDetailUrl = () => {
  return apiUrl + '/user-gifts-v2/gift';
};
export const sendOTPforGiftUrl = () => {
  return apiUrl + '/user-gifts-v2/send-otp-for-gift';
};
export const verifyOTPforGiftUrl = () => {
  return apiUrl + '/user-gifts-v2/verify-otp-for-gift';
};
export const giftHistoryUrl = () => {
  return apiUrl + '/user-gifts-v2/gift-history';
};
export const UploadGiftImageUrl = () => {
  return apiUrl + '/user-gifts-v2/upload-image-for-gift';
};
